import { Injectable, Inject } from '@angular/core';
import { Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { tokenNotExpired, AuthHttp } from 'angular2-jwt';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { Router } from '@angular/router';

import { ModPass, Profilo, StaticUrls } from '../models';
import { MyCookieService } from './my-cookie.service';
import { environment } from 'environments/environment';

@Injectable()
export class ProfiloService {

	private profilo: Profilo;
	private headers = new Headers({ 'Content-Type': 'application/json' });
	private options = new RequestOptions({ headers: this.headers });

	constructor(private http: AuthHttp,
		@Inject(MyCookieService) private myCookieService: MyCookieService,
		private router: Router
	) { }

	verificaUsername(username: string): Observable<{found: boolean, username: string}> {

		return this.http.get(StaticUrls._checkUsername(username))
			.map(response => {
				if (response.text() === 'trovato') {
					return {found: true, username: username};
				} else {
					return {found: false, username: username};
				}
			});
	}

	verificaEmail(mail: string): Observable<boolean> {

		return this.http.get(StaticUrls._checkMail(mail))
			.map(response => {
				if (response.text() === 'trovato') {
					return true;
				} else {
					return false;
				}
			});
	}

	verificaCF(cf: string): Observable<boolean> {

		return this.http.get(StaticUrls._checkCF(cf))
			.map(response => {
				if (response.text() === 'trovato') {
					return true;
				} else {
					return false;
				}
			});
	}

	verificaPIva(pIva: string): Observable<boolean> {

		return this.http.get(StaticUrls._checkPIva(pIva))
			.map(response => {
				if (response.text() === 'trovato') {
					return true;
				} else {
					return false;
				}
			});
	}

	cancellazioneLogica(utente: Profilo): Observable<Response> 
	{
		if (this.myCookieService.token) 
		{
			if (tokenNotExpired(environment.tokenName)) 
			{
				return this.http.put(StaticUrls._cancellazioneLogicaProfilo(utente.id), this.options);
			}
		}
	}

	post(profilo: Profilo): Observable<Response> {
		return this.http.post(StaticUrls._profilo, JSON.stringify(profilo), this.options)
			.map((response: Response) => {
					return response;
			});
	}

	uploadDocumentoIdentita(username: string, uploader: FileUploader) {
		this.ifTokenNotExpired();

		let options: FileUploaderOptions = uploader.options;
		options.url = StaticUrls._documentoIdentitaUtente(username);
		if(this.myCookieService.token){
			options.authToken = localStorage.getItem(environment.tokenName);
		}
		options.authTokenHeader = environment.headerName;
		uploader.setOptions(options);
		uploader.uploadAll();
	}

	uploadVisuraCamerale(username: string, uploader: FileUploader) {
		this.ifTokenNotExpired();

		let options: FileUploaderOptions = uploader.options;
		options.url = StaticUrls._documentoVisuraCamerale(username);
		if(this.myCookieService.token){
			options.authToken = localStorage.getItem(environment.tokenName);
		}
		options.authTokenHeader = environment.headerName;
		uploader.setOptions(options);
		uploader.uploadAll();
	}

	uploadContratto(username: string, uploader: FileUploader) {
		this.ifTokenNotExpired();

		let options: FileUploaderOptions = uploader.options;
		options.url = StaticUrls._contrattoUtente(username);
		if(this.myCookieService.token){
			options.authToken = localStorage.getItem(environment.tokenName);
		}
		options.authTokenHeader = environment.headerName;
		uploader.setOptions(options);
		uploader.uploadAll();

		uploader.onCompleteAll;
	}

	get(): Observable<Profilo> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			
			return this.http.get(StaticUrls._profilo, this.options)
				.map(this.extractData)
				.catch(this.handleError);
		}
	}

	getNumeroUtenti(): Observable<number> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();

			return this.http.get(StaticUrls._countUtenti, this.options)
				.map( result => { return result.json(); })
				.catch(this.handleError);
		}

	}

	getByUserid(userid: string): Observable<Profilo> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._profilo + "/username/" + userid, this.options)
				.map(this.extractData)
				.catch(this.handleError);
		}
	}

	getByIdCollaboratore(id: number): Observable<Profilo> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._profilo + "/collaboratore/" + id, this.options)
				.map(this.extractData)
				.catch(this.handleError);
		}
	}

	search(searchObj: Profilo): Observable<Profilo[]> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();

			return this.http.post(StaticUrls._searchUtenti, JSON.stringify(searchObj), this.options)
				.map(response => {
					return response.json();
				})
				.catch(this.handleError);
		}
	}

	update(profilo: Profilo): Observable<Response> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.put(StaticUrls._profilo, JSON.stringify(profilo), this.options)
				.map((response: Response) => { return response; })
				.catch(this.handleError);
		}
	}

	updatePassword(modPass: ModPass): Observable<Response> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.put(StaticUrls._updatePass, JSON.stringify(modPass), this.options)
				.map((response: Response) => { return response; });
		}
	}

	updateAccessoApp(profilo: Profilo): Observable<Response> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.post(StaticUrls._updateAccessoApp, JSON.stringify(profilo), this.options)
				.map((response: Response) => { return response; })
				.catch(this.handleError);
		}
	}

	updateAccessoImmobile(profilo: Profilo): Observable<Response> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired()
			return this.http.post(StaticUrls._updateAccessoImmobile, JSON.stringify(profilo), this.options)
				.map((response: Response) => { return response; })
				.catch(this.handleError);
		}
	}

	updateImportoMassimo(profilo: Profilo) {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.post(StaticUrls._importoProfilo, JSON.stringify(profilo), this.options)
				.map((response: Response) => { return response; })
				.catch(this.handleError);
		}
	}

	updateImportoMassimoById(id: number, importo: number) {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.post(StaticUrls._importoProfiloById(id, importo), null, this.options)
				.map((response: Response) => { return response; })
				.catch(this.handleError);
		}
	}

	private extractData(res: Response) {
		this.profilo = res.json();
		return this.profilo;
	}

	private handleError(error: Response | any) {
		let errMsg: string;

		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
			if (error.status == 401) {
				this.router.navigate(['login']);
			}
		} else {
			errMsg = error.message ? error.message : error.toString();
		}
		console.error(errMsg);
		return Observable.throw(errMsg);
	}

	private ifTokenNotExpired() {
		if(this.myCookieService.token){
			if (!tokenNotExpired(environment.tokenName)) {
				this.router.navigate(['login']);
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}

}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/profilo.service.ts